import { render, staticRenderFns } from "./ComponentIcon.vue?vue&type=template&id=45172d22&"
import script from "./ComponentIcon.vue?vue&type=script&lang=js&"
export * from "./ComponentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports